import { render, staticRenderFns } from "./BdWeWorkInternal.vue?vue&type=template&id=d79b8e88&"
import script from "./BdWeWorkInternal.vue?vue&type=script&lang=js&"
export * from "./BdWeWorkInternal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports